import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminRejectPcmpProposal } from '../api/pcmpProposals.api';
import type { PcmpAdminRejectResult } from '../types/pcmpProposal.types';
import { pcmpActionCallbacks } from '../utils/pcmpActionCallbacks';

/** Admin reject of one proposal; final. */
export function useAdminRejectPcmpProposal(proposalId: number, onSuccess: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (reason: string) => adminRejectPcmpProposal(proposalId, { reason }),
    ...pcmpActionCallbacks<PcmpAdminRejectResult>(
      queryClient,
      (result) =>
        result.removedFromBatchNo === null
          ? 'Proposal rejected'
          : `Proposal rejected and removed from batch #${result.removedFromBatchNo}`,
      onSuccess,
    ),
  });
}
